import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams ,LoadingController} from 'ionic-angular';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonProvider } from '../../providers/common/common';
import {GenericFormValidationProvider} from "../../providers/common/form-validation"

import {CoFinancialdetailsPage} from '../co-financialdetails/co-financialdetails';

/**
 * Generated class for the CoPersonaldetailsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-co-personaldetails',
  templateUrl: 'co-personaldetails.html',
})
export class CoPersonaldetailsPage {

   model:any={}
  modelRequest:any={}
  fetchData:any = {}
  latestNavParams:any={}
  fetchPincodeData:any = {}
  modelLead:any={}
  dailingCodes:any=[];
  errorDisplay:any={};
  country_code:any="";
  phone_number: any;
  relationships:any=[];
  errorSingleDisplay:any={}; 
  dateC:any="";
  year:any="";
  constructor(
    private cp: CommonProvider, public loadingCtrl: LoadingController,
    public navCtrl: NavController, public navParams: NavParams,
    private fb: FormBuilder,
    private fv : GenericFormValidationProvider

    ) {
    this.model.lead={};
    this.modelRequest.lead={};
    this.fetchPincodeData.ibhfl_city={}
    
     // this.modelRequest.applicants[0]={}
    
  }

  ionViewDidLoad() {

    const d = new Date();
    this.year = d.getFullYear()-17;
    this.dateC = this.year+'-01'+'-01'; 
    ////console.log('ionViewDidLoad AppPersonalInfoPage',JSON.parse(this.navParams.data));
    localStorage.setItem("loantype",JSON.parse(this.navParams.data).Payload.lead.ibhfl_purposeproduct)
    this.model.lead.ibhfl_residentialstatusid="RI";
    this.model.lead.ibhfl_Occupationid="28"
    // this.fetchData = JSON.parse(this.navParams.data).Payload.lead
    this.model.lead.ibhfl_relationship="";
    this.veiwLead(JSON.parse(this.navParams.data).Payload.lead.leadid)
    
    
  }
  veiwLead(leadid,create?:any){
    let request:any = {};
      //////console.log(leadid)
      request.leadId=leadid
       
      // //////console.log(request);

      // return false;
      let loading = this.loadingCtrl.create({
           content: 'Please wait...'
          });
          loading.present();
      this.cp.viewLeadById(loading,request).then((res:any)=>{
         loading.dismiss();
         try{
             this.latestNavParams=res;
             this.fetchData = JSON.parse(res).Payload.lead;
             //console.log("co-personal",this.fetchData);
             if(create){
                this.updateData(JSON.parse(res).Payload.lead)
             }else{


             this.model.lead={};
             // this.fetchData.applicants=this.fetchData.applicants.filter((res:any)=>{
             //    return res.ibhfl_applicantrole=="303710001" && res.ibhfl_panverified==false
             //  })
              // this.model.lead=this.fetchData;
              // //////console.log(this.model.lead)

              this.model.applicants=this.fetchData.applicants;
              this.model.lead.leadid=this.fetchData.leadid;
              // if(this.fetchData.applicants.length>0){


              // this.model.lead.ibhfl_applicanttype=this.fetchData.applicants[0].ibhfl_applicanttype;
               this.model.lead.ibhfl_residentialstatusid=this.fetchData.ibhfl_residentialstatusid?this.fetchData.ibhfl_residentialstatusid:'RI';
              // this.model.lead.ibhfl_Occupationid=this.fetchData.applicants[0].ibhfl_Occupationid
              // let occup_name :any = ""
              // if(this.model.lead.ibhfl_Occupationid==28){
              //   occup_name = "Salaried"
              // }else if(this.model.lead.ibhfl_Occupationid==29){
              //   occup_name = "Self-employed"
              // }else if(this.model.lead.ibhfl_Occupationid==30){
              //   occup_name = "Professional"
              // }else{
              //   occup_name = "Non Working"
              // }
              // this.model.lead.ibhfl_Occupationid_name=occup_name
              // this.model.lead.firstname=this.fetchData.applicants[0].ibhfl_firstname
              // this.model.lead.middlename=this.fetchData.applicants[0].ibhfl_middlename
              // this.model.lead.lastname=this.fetchData.applicants[0].ibhfl_lastname
              // this.model.lead.mobilephone1 = this.fetchData.applicants[0].ibhfl_mobilephone1
              // this.model.lead.ibhfl_genderid=this.fetchData.applicants.length>0?this.fetchData.applicants[0].ibhfl_genderid:""
              // this.model.lead.ibhfl_dateofbirth=this.fetchData.applicants[0].ibhfl_dateofbirth
              // this.model.lead.pincode=this.fetchData.applicants[0].pincode
              // this.model.lead.city_name=this.fetchData.applicants[0].city_name
              // this.model.lead.state=this.fetchData.applicants[0].state
              // this.model.lead.ibhfl_stageid="5";
              // this.model.lead.ibhfl_relationship=this.fetchData.applicants[0].ibhfl_relationship;
              // }
              this.modelLead=this.model.lead;
              this.pincodeUpdate();
              this.getDailingCodeAllCountry();
              this.getRelationships()
              }
         }catch(e){
          ////console.log(e)
         }
       })
  }
  getDailingCodeAllCountry(){
  let loading = this.loadingCtrl.create({
    content: 'Please wait...'
  });
  loading.present();
    let data = this.cp.getDailingCodeAllCountries(loading) ;
    data.then((res:any)=>{
      loading.dismiss();
      this.dailingCodes=JSON.parse(res).Payload.ibhfl_countrydialingcodes;
      this.country_code=this.dailingCodes[0].ibhfl_name;
    })
   
    
  }
  getRelationships(){
  let loading = this.loadingCtrl.create({
    content: 'Please wait...'
  });
  loading.present();
    let data = this.cp.getRelationships(loading) ;
    data.then((res:any)=>{
      loading.dismiss();
      ////console.log("relationships data",JSON.parse(res).Payload);
      this.relationships=JSON.parse(res).Payload.ibhfl_relations;
       
    })
   
    
  }
  pincodeUpdate(){
    if(this.model.lead.pincode ){
      //////console.log("pincode updated",this.model.lead.pincode);
    let loading = this.loadingCtrl.create({
           content: 'Please wait...'
          });
          loading.present();
    let request:any={}
    request.pincodeID = this.model.lead.pincode     
    this.cp.getCityByPincode(loading,request).then((res:any)=>{
      loading.dismiss();

       ////console.log(JSON.parse(res),"res data");
       if(JSON.parse(res).Payload.ibhfl_pincodes.length>0){


       this.model.lead.city_name = JSON.parse(res).Payload.ibhfl_pincodes?JSON.parse(res).Payload.ibhfl_pincodes[0].ibhfl_city.ibhfl_name:"";
       this.fetchPincodeData = JSON.parse(res).Payload.ibhfl_pincodes[0];

       }
    })
    }
    
  }
   createApplicantByLeadID(lead){
     let loading = this.loadingCtrl.create({
           content: 'Please wait...'
          });
          loading.present();
          let occup_name :any = ""
          if(this.model.lead.ibhfl_Occupationid==28){
            occup_name = "Salaried"
          }else if(this.model.lead.ibhfl_Occupationid==29){
            occup_name = "Self-employed"
          }else if(this.model.lead.ibhfl_Occupationid==30){
            occup_name = "Professional"
          }else{
            occup_name = "Non Working"
          }
          let getDta:any=[]
          getDta=this.fetchData.applicants.filter((res:any)=>{
            return res.ibhfl_applicantrole=="303710001" && res.ibhfl_panverified==true
          })
          getDta.sort((a,b)=>{
            return b.ibhfl_coapplicantnumber-a.ibhfl_coapplicantnumber
          })
          var ibhfl_coapplicantnumber=parseInt(getDta.length)+1
          // if(getDta.length>=1){
          //   ibhfl_coapplicantnumber=getDta[getDta.length-1].ibhfl_coapplicantnumber+1
          // }
          let request : any={
              "lead": {
                  "leadid": lead,
                   
              },
              "applicants": [
                  {
                      "ibhfl_applicantrole": "303710001",
                      "ibhfl_residentialstatusid": this.model.lead.ibhfl_residentialstatusid,
                      "ibhfl_applicanttype": "303710000",
                      "ibhfl_coapplicantnumber": ibhfl_coapplicantnumber,
                      "ibhfl_relationship":this.model.lead.ibhfl_relationship,
                      "preferredAddressType": "CURRES",
                      "ibhfl_PrimaryApplicant": JSON.parse(this.navParams.data).Payload.lead.applicants[0].applicantid,
                      "ibhfl_Occupationid": this.model.lead.ibhfl_Occupationid,

                      "ibhfl_Occupationid_name": occup_name,

                      "ibhfl_firstname": this.model.lead.firstname,

                      "ibhfl_middlename": this.model.lead.middlename,
                      "ibhfl_lastname": this.model.lead.lastname,
                      "ibhfl_genderid": this.model.lead.genderid,
                      "ibhfl_dateofbirth": this.model.lead.ibhfl_dateofbirth,
                      "ibhfl_mobilephone1": this.model.lead.mobilephone1,
                      "pincode": this.model.lead.pincode,
                      // "city": this.fetchPincodeData.ibhfl_city?this.fetchPincodeData.ibhfl_city.ibhfl_citycode.toString():"",
                      // "state": this.fetchPincodeData.ibhfl_state?this.fetchPincodeData.ibhfl_state.ibhfl_statecode.toString():"",



                      "addresses": [
                          {
                              "addressType": "CURRES"
                          },
                          {
                              "addressType": "PERRES"
                          },
                          {
                              "addressType": "OFFICE"
                          }
                      ]
                  }
              ]
          }
          //console.log("aaaa",request);
      this.cp.createLead(loading,request).then((res:any)=>{
         loading.dismiss();
         try{
          //console.log("create lead data",JSON.parse(res))
          if(JSON.parse(res).Error && JSON.parse(res).Error.ErrorCode==400){
            alert("You have created lead already!")
          }else{
            this.veiwLead(JSON.parse(res).Payload.lead.leadid,true)
            // this.navCtrl.setRoot(AppPersonalInfoPage,{'loantype':loantype})
          }

         }catch(e){
           
         } 
           
      })
  }
  // checkValidation(keyname?:any){
  //  if(Object.keys(this.errorDisplay).length>0){
  //   this.errorDisplay = this.fv.checkValidationFormAllControls(document.forms['copersonal'],true,[]);
   
  //  }
  // }
  checkValidation(keyname?:any){
   if(Object.keys(this.errorDisplay).length>0){
    this.errorSingleDisplay = this.fv.checkValidationFormAllControls(document.forms['copersonal'],true,[]);
    if(Object.keys(this.errorSingleDisplay).length>0){
     var index = Object.keys(this.errorSingleDisplay).findIndex((res:any)=>{
        return res==keyname
      })
        //console.log(index);

      if(index==-1){
        delete this.errorDisplay[keyname];
        if(this.errorDisplay.length>0 && this.errorDisplay.length<=1)
        {
          this.errorDisplay.valid=false
        }
        //console.log(this.errorDisplay);
      }
    }
    
   }
   
  }
  updateInfo(){
    this.errorDisplay = this.fv.checkValidationFormAllControls(document.forms["copersonal"],true,[]);
    if(this.errorDisplay.valid){
     return false;
   }else{
    this.createApplicantByLeadID(this.model.lead.leadid)
      // this.fetchData.applicants=this.fetchData.applicants.filter((res:any)=>{
      //   return res.ibhfl_applicantrole=="303710001"
      // })
      // if(this.fetchData.applicants.length==0){
      //   this.createApplicantByLeadID(this.model.lead.leadid)
      // }else{
      //    this.updateData(this.fetchData)
      // }
   } 
     
    
  }
  updateData(fetchdata){
    this.fetchData=fetchdata
    let occup_name :any = ""
    if(this.model.lead.ibhfl_Occupationid==28){
      occup_name = "Salaried"
    }else if(this.model.lead.ibhfl_Occupationid==29){
      occup_name = "Self-employed"
    }else if(this.model.lead.ibhfl_Occupationid==30){
      occup_name = "Professional"
    }else{
      occup_name = "Non Working"
    }
    this.modelRequest.applicants=[{}];
    this.modelRequest.lead.leadid = this.modelLead.leadid
    this.modelRequest.lead.ibhfl_stageid = "5"
    // this.modelRequest.applicants[0].ibhfl_applicantrole = this.fetchData.applicants[0].ibhfl_applicantrole.toString()?this.fetchData.applicants[0].ibhfl_applicantrole.toString():"303710001"
    this.modelRequest.applicants[0].ibhfl_residentialstatusid = this.model.lead.ibhfl_residentialstatusid
    
    this.modelRequest.applicants[0].ibhfl_residentialstatusid = this.fetchData.applicants[0].ibhfl_residentialstatusid?this.fetchData.applicants[0].ibhfl_residentialstatusid:this.model.lead.ibhfl_residentialstatusid
    this.modelRequest.applicants[0].ibhfl_applicanttype= this.fetchData.applicants[0].ibhfl_applicanttype.toString()?this.fetchData.applicants[0].ibhfl_applicanttype.toString():"303710000"
    this.modelRequest.applicants[0].ibhfl_Occupationid= this.fetchData.applicants[0].ibhfl_Occupationid.toString()?this.fetchData.applicants[0].ibhfl_Occupationid.toString():this.model.lead.ibhfl_Occupationid
    this.modelRequest.applicants[0].ibhfl_Occupationid_name= this.fetchData.ibhfl_Occupationid_name?this.fetchData.ibhfl_Occupationid_name:occup_name
    this.modelRequest.applicants[0].ibhfl_firstname= this.fetchData.applicants[0].ibhfl_firstname?this.fetchData.applicants[0].ibhfl_firstname:this.model.lead.firstname

    this.modelRequest.applicants[0].ibhfl_middlename= this.fetchData.applicants[0].ibhfl_middlename?this.fetchData.applicants[0].ibhfl_middlename:this.model.lead.middlename
    
    this.modelRequest.applicants[0].ibhfl_lastname= this.fetchData.applicants[0].ibhfl_lastname?this.fetchData.applicants[0].ibhfl_lastname:this.model.lead.lastname
    this.modelRequest.applicants[0].ibhfl_genderid= this.fetchData.applicants[0].ibhfl_genderid?this.fetchData.applicants[0].ibhfl_genderid:this.model.lead.ibhfl_genderid
    this.modelRequest.applicants[0].ibhfl_dateofbirth= this.model.lead.ibhfl_dateofbirth
    this.modelRequest.applicants[0].preferredAddressType= this.fetchData.applicants[0].preferredAddressType
    this.modelRequest.applicants[0].ibhfl_mobilephone1= this.model.lead.mobilephone1
    this.modelRequest.applicants[0].applicantid= this.fetchData.applicants[0].applicantid.toString()
    this.modelRequest.applicants[0].pincode= this.model.lead.pincode
    let getDta:any=[]
          getDta=this.fetchData.applicants.filter((res:any)=>{
            return res.ibhfl_applicantrole=="303710001" && res.ibhfl_panverified==true
          })
          getDta.sort((a,b)=>{
            return b.ibhfl_coapplicantnumber-a.ibhfl_coapplicantnumber
          })
    var ibhfl_coapplicantnumber=1
          if(getDta.length>1){
            ibhfl_coapplicantnumber=getDta[getDta.length-1].ibhfl_coapplicantnumber+1
          }
    this.modelRequest.applicants[0].ibhfl_coapplicantnumber = ibhfl_coapplicantnumber.toString()
    this.modelRequest.applicants[0].ibhfl_relationship= this.model.lead.ibhfl_relationship
    
    // this.modelRequest.applicants[0].city= this.fetchPincodeData.ibhfl_city.ibhfl_citycode.toString()
    // this.modelRequest.applicants[0].state=this.fetchPincodeData.ibhfl_state.ibhfl_statecode.toString()
    // this.modelRequest.applicants[0].addresses= this.fetchData.applicants[0].addresses
    this.fetchData.applicants[0].addresses.forEach((getRes:any)=>{
      if(getRes.addressType=="CURRES"){
        let objAddCurr:any = {}
        objAddCurr.addressType = getRes.addressType
        objAddCurr.addressid  = getRes.addressid
        objAddCurr.pincode  = getRes.pincode ?getRes.pincode:this.model.lead.pincode
        // objAddCurr.city   = getRes.city ?getRes.city:this.fetchPincodeData.ibhfl_city.ibhfl_citycode.toString()
        // objAddCurr.state  = getRes.state ?getRes.state:this.fetchPincodeData.ibhfl_state.ibhfl_statecode.toString()
        // objAddCurr.country  = getRes.country 

        this.modelRequest.applicants[0].addresses=[objAddCurr]
      }
    })

    // this.modelRequest.lead.city= this.fetchPincodeData.ibhfl_city.ibhfl_citycode.toString()
    // this.modelRequest.lead.state=this.fetchPincodeData.ibhfl_state.ibhfl_statecode.toString()
    this.modelRequest.lead.ibhfl_applicanttype=this.fetchData.applicants[0].ibhfl_applicanttype.toString()
    let loading = this.loadingCtrl.create({
           content: 'Please wait...'
          });
          loading.present();
    let request:any={}
     
    ////console.log("city goted",this.model,this.modelRequest);
    // loading.dismiss();
    //  return false
    try{
      this.cp.updateLead(loading,this.modelRequest).then((res:any)=>{
      loading.dismiss();
       
      let responce :any ={}
      ////console.log(JSON.parse(res))
       if(JSON.parse(res).Payload){
        
        this.navCtrl.push(CoFinancialdetailsPage,this.latestNavParams)
       }else{

       }

       
       
    })
    }catch(e){
      ////console.log(e)
    }
  }
  resetData(citizanShip){
    ////console.log(citizanShip)
    if(citizanShip=='RI'){

    }else{
      this.model.lead.ibhfl_Occupationid="28"
      this.model.lead.account_type=''
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/co-personaldetails/co-personaldetails.ts